define('services/app-state',[
    // libs
    'underscore', 'backbone', 'color'
], function(
    _, Backbone, Color
) {

    var State = Backbone.Model.extend({

        setBrandColor: function(hexColor, options) {

            //if invalid color, default blue TC
            if (!/^#[0-9A-F]{6}$/i.test(hexColor)) {
              hexColor = '#00adef';
            }
            return this.set({ color: new Color(hexColor) }, options);
        },

        getBrandColor: function() {
            return this.get('color');
        },

        onClientSide: function() {
            return ! Backbone.history.getFragment().includes('supervisor');
        },

        onSupervisorSide: function() {
            return ! this.onClientSide();
        }
    });

    return new State();
});

